<template>
    <div class="row">
                <div class="col-xs-12 col-md-12">
                    <h6>FILTER</h6>
                </div>
                <div class="col-md-12 filter-block">
                    <div class="row">
                        <div class="col-md-2">
                            <div class="filterSelect">
                                <select class="form-group" name="brand" @change="onChangeBrand" v-model="form.brand">
                                    <option :data-id="0" :value="0">Alle Marken...</option>
                                    <option v-for="brand in brands" :data-id="brand.id" :value="brand.id" :key="brand.id">{{brand.description}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-2">
                            <div class="filterSelect">
                                <select class="form-group" name="model" v-model="form.model">
                                    <option :data-id="0" :value="0">Alle Modelle...</option>
                                    <option v-for="model in models" :data-id="model.id" :value="model.id" :key="model.id">{{model.description}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="filterSelect">
                                <select class="form-group" name="gear" v-model="form.gear">
                                    <option :data-id="0" :value="0">Getriebeart</option>
                                    <option v-for="gear in gears" :data-id="gear.id" :value="gear.id" :key="gear.id">{{gear.description}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-2">
                            <div class="filterSelect">
                                <select class="form-group" name="fuel" v-model="form.fuel">
                                    <option :data-id="0" :value="0">Treibstoff</option>
                                    <option v-for="fuel in fuels" :data-id="fuel.id" :value="fuel.id" :key="fuel.id">{{fuel.description}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="filterSelect">
                                <select class="form-group" name="location" v-model="form.location">
                                    <option :data-id="0" :value="0">Alle Standorte</option>
                                    <option v-for="location in locations" :data-id="location.id" :value="location.id" :key="location.id">{{location.description}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-2">
                            <div class="filterSelect">
                                <select class="form-group" name="km" v-model="form.km">
                                    <option :data-id="0" :value="0">KM bis</option>
                                    <option v-for="km in kms" :data-id="km.id" :value="km.id" :key="km.id">{{km.description}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-2">
                            <div class="filterSelect">
                                <select class="form-group" name="price" v-model="form.price">
                                    <option :data-id="0" :value="0">Preis bis</option>
                                    <option v-for="price in prices" :data-id="price.id" :value="price.id" :key="price.id">{{price.description}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="filterSelect">
                                <select class="form-group" name="type" v-model="form.type">
                                    <option :data-id="0" :value="0">Aufbau</option>
                                    <option v-for="cartype in types" :data-id="cartype.id" :value="cartype.id" :key="cartype.id">{{cartype.description}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-2">
                            <div class="filterSelect">
                                <select class="form-group" name="year" v-model="form.year">
                                    <option :data-id="0" :value="0">EZ ab</option>
                                    <option v-for="year in years" :data-id="year.id" :value="year.id" :key="year.id">{{year.description}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="filterSelect">
                                <select class="form-group" name="power" v-model="form.power">
                                    <option :data-id="0" :value="0">Alle Stärken</option>
                                    <option v-for="power in powers" :data-id="power.id" :value="power.id" :key="power.id">{{power.description}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                            <span class="sort-desc">Nach Preis sortieren:</span> <span v-if="isAsc">Aufsteigend</span><span v-else><a href="#" class="sortlink" @click="sortAsc">Aufsteigend</a></span> / <span v-if="isDesc">Absteigend</span><span v-else><a href="#" class="sortlink" @click="sortDesc">Absteigend</a></span>
                        </div>
                        <div class="col-md-2 col-md-push-4">
                            <a href="#" class="btn" style="margin-top: -8px;" @click="reset">Zurücksetzen</a>
                        </div>
                        <div class="col-md-2 col-md-push-4">
                            <a href="#" class="btn" style="margin-top: -8px;" @click="onClick">Filtern</a>
                        </div>
                    </div>
                </div> 
            </div>
</template>

<script>
    export default {
        props: {
            brand: {
                type: [String],
                required: false,
                default: 0
            },
            model: {
                type: [String],
                required: false,
                default: 0
            },
            km: {
                type: [String],
                required: false,
                default: 0
            },
            price: {
                type: [String],
                required: false,
                default: 0
            },
            gear: {
                type: [String],
                required: false,
                default: 0
            },
            fuel: {
                type: [String],
                required: false,
                default: 0
            },
            type: {
                type: [String],
                required: false,
                default: 0
            },
            year: {
                type: [String],
                required: false,
                default: 0
            },
            location: {
                type: [String],
                required: false,
                default: 0
            },
            power: {
                type: [String, Number],
                required: false,
                default: 0
            },
            sort: {
                type: [String],
                required: false,
                default: ""
            }
        },
        data() {
            return {
                form: new Form({
                    brand: 0,
                    model: 0,
                    km: 0,
                    price: 0,
                    gear: 0,
                    fuel: 0,
                    type: 0,
                    year: 0,
                    location: 0,
                    power: 0
                }),
                brands: [],
                models: [],
                kms: [],
                prices: [],
                gears: [],
                fuels: [],
                types: [],
                years: [],
                locations: [],
                powers: [],
                sorting: this.sort
            }
        },
        computed: {
            isDesc: function() {
                return this.sort == "desc";
            },
            isAsc: function() {
                return this.sort == "asc";
            }
        },
        methods: {
            onChangeBrand(e) {
                let select = e.currentTarget;
                if(select.options[select.selectedIndex].dataset.id == 0) {
                    this.form.model = 0;
                    this.models = [];
                } else {
                    new Form({id: select.options[select.selectedIndex].dataset.id, noSave: true})
                        .post('/api/models')
                        .then((models) => {
                            App.event.fire('car.brand.loaded.form', models);
                            this.form.model = 0;
                        });
                }
                
            },
            onClick() {
                window.location = App.url+'/gebrauchtwagen?brand='+this.form.brand+
                '&model='+this.form.model+
                '&km='+this.form.km+
                '&price='+this.form.price+
                '&gear='+this.form.gear+
                '&fuel='+this.form.fuel+
                '&type='+this.form.type+
                '&year='+this.form.year+
                '&location='+this.form.location+
                '&power='+this.form.power+
                '&sort='+this.sort;
            },

            reset() {
                window.location = App.url+'/gebrauchtwagen';
            },

            sortAsc() {
                window.location = App.url+'/gebrauchtwagen?brand='+this.form.brand+
                '&model='+this.form.model+
                '&km='+this.form.km+
                '&price='+this.form.price+
                '&gear='+this.form.gear+
                '&fuel='+this.form.fuel+
                '&type='+this.form.type+
                '&year='+this.form.year+
                '&location='+this.form.location+
                '&power='+this.form.power+
                '&sort=asc';
            },

            sortDesc() {
                window.location = App.url+'/gebrauchtwagen?brand='+this.form.brand+
                '&model='+this.form.model+
                '&km='+this.form.km+
                '&price='+this.form.price+
                '&gear='+this.form.gear+
                '&fuel='+this.form.fuel+
                '&type='+this.form.type+
                '&year='+this.form.year+
                '&location='+this.form.location+
                '&power='+this.form.power+
                '&sort=desc';
            }
        },
        created() {

            this.form.brand = this.brand;
            if(this.brand != 0) {
                new Form({id: this.brand, noSave: true})
                    .post('/api/models')
                    .then((models) => {
                        App.event.fire('car.brand.loaded.form', models);
                        this.form.model = this.model;
                    });
            }
            this.form.km = this.km;
            this.form.price = this.price;
            this.form.gear = this.gear;
            this.form.fuel = this.fuel;
            this.form.type = this.type;
            this.form.year = this.year;
            this.form.location = this.location;
            this.form.power = this.power;

            App.event.listen('car.brands.loaded', (brands) => {
                this.brands = brands;
            });

            App.event.listen('car.brand.loaded.form', (models) => {
                this.models = models;
            });

            App.event.listen('car.kms.loaded', (kms) => {
                this.kms = kms;
            });

            App.event.listen('car.prices.loaded', (prices) => {
                this.prices = prices;
            });

            App.event.listen('car.gears.loaded', (gears) => {
                this.gears = gears;
            });

            App.event.listen('car.fuels.loaded', (fuels) => {
                this.fuels = fuels;
            });

            App.event.listen('car.types.loaded', (types) => {
                this.types = types;
            });

            App.event.listen('car.years.loaded', (years) => {
                this.years = years;
            });

            App.event.listen('car.locations.loaded', (locations) => {
                this.locations = locations;
            });

            App.event.listen('car.power.loaded', (power) => {
                this.powers = power;
            });
        },
    }
</script>